export default __webpack_public_path__ + "static/media/spr-components-light.f8804d03.png";